import _ from 'lodash';
import React, { Component } from 'react';
import { Button, Form, Input } from 'antd';
import { gql } from '@apollo/client';
import styles from './styles.scss';

const PRODUCT_PRICE = gql`
  query ProductPrice($input: ProductPriceInput) {
    productPrice(input: $input) {
      price
      errors {
        detail
      }
    }
  }
`;

class PromoCodeForm extends Component {
  constructor(props) {
    super(props);

    const { code } = props;

    this.state = {
      code,
      errorDetail: null,
    };
  }

  componentDidMount() {
    const { code } = this.props;

    if (!_.isEmpty(code)) {
      this.queryPromoPrice({ code });
    }
  }

  clearCode = () => {
    const { product, setParentState } = this.props;
    const { price } = product;

    this.setState({
      code: null,
    });

    setParentState({
      code: null,
      price,
    });
  };

  queryPromoPrice = async ({ code }) => {
    const { client, product, organizationUuid, setParentState } = this.props;

    if (_.isEmpty(code)) {
      return;
    }

    this.setState({
      loading: true,
    });

    setParentState({
      code: null,
      promoCodeProcessing: true,
    });

    try {
      const { data } = await client.query({
        query: PRODUCT_PRICE,
        variables: {
          input: {
            productSlug: product.slug,
            code,
            organizationUuid,
          },
        },
      });

      const {
        productPrice: { price, errors },
      } = data;

      // 20190320JP: Null check since price could be 0
      if (price === null) {
        const errorDetail = errors[0].detail;

        this.setState({
          loading: false,
          errorDetail,
        });

        setParentState({
          code: null,
          promoCodeProcessing: false,
        });
        return;
      }

      this.setState({
        code,
        loading: false,
      });

      setParentState({
        code,
        price,
        promoCodeProcessing: false,
      });
    } catch (promoCodeError) {
      this.setState({
        loading: false,
      });

      setParentState({
        code: null,
        promoCodeProcessing: false,
      });
    }
  };

  onFinish = (values) => {
    this.setState({
      errorDetail: null,
    });

    const { code } = values;
    this.queryPromoPrice({ code });
  };

  render() {
    const { code, errorDetail, loading } = this.state;

    return (
      <Form onFinish={this.onFinish}>
        {code ? (
          <div className={styles.promoCodeApplied}>
            <span>Using code: {code}</span>
            <i
              data-aaa="clearPromoCode"
              className="fas fa-times"
              onClick={this.clearCode}
            />
          </div>
        ) : (
          <div className={styles.promoCodeForm}>
            <div className={styles.promoCodeInputs}>
              <Form.Item noStyle name="code">
                <Input
                  data-aaa="promoCode"
                  placeholder="code"
                  disabled={loading}
                  className={styles.codeInput}
                />
              </Form.Item>
              <Button
                data-aaa="applyPromoCode"
                type="ghost"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                Apply
              </Button>
            </div>
            <div className={styles.promoCodeError}>{errorDetail}</div>
          </div>
        )}
      </Form>
    );
  }
}

export default PromoCodeForm;
